export default __webpack_public_path__ + "static/media/editar-button.3e88895c.svg";